export default __webpack_public_path__ + "assets/spaceComm.8a3db545.png";